import { render, staticRenderFns } from "./CustomFilter.vue?vue&type=template&id=1f64c8a5&scoped=true"
import script from "./CustomFilter.vue?vue&type=script&lang=js"
export * from "./CustomFilter.vue?vue&type=script&lang=js"
import style0 from "./CustomFilter.vue?vue&type=style&index=0&id=1f64c8a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f64c8a5",
  null
  
)

export default component.exports